var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Bluetooth component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconBluetooth extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3003 1.17153C11.5683 1.04993 11.8826 1.09629 12.1041 1.29007L18.3472 6.75276C18.5184 6.90262 18.6124 7.12212 18.6026 7.34947C18.5928 7.57682 18.4803 7.78743 18.2968 7.922L12.7366 11.9995L18.2968 16.077C18.4803 16.2116 18.5928 16.4222 18.6026 16.6495C18.6124 16.8769 18.5184 17.0964 18.3472 17.2462L12.1041 22.7089C11.8826 22.9027 11.5683 22.9491 11.3003 22.8275C11.0323 22.7059 10.8602 22.4388 10.8602 22.1445V13.3755L6.59103 16.5062C6.25701 16.7512 5.78766 16.679 5.54271 16.345C5.29776 16.0109 5.36996 15.5416 5.70399 15.2966L10.2001 11.9995L5.70399 8.70238C5.36996 8.45743 5.29776 7.98808 5.54271 7.65406C5.78766 7.32003 6.25701 7.24783 6.59103 7.49278L10.8602 10.6235V1.8545C10.8602 1.56022 11.0323 1.29313 11.3003 1.17153ZM12.3602 13.5836L16.6554 16.7334L12.3602 20.4917V13.5836ZM12.3602 10.4154V3.50733L16.6554 7.26561L12.3602 10.4154Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconBluetooth.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconBluetooth.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconBluetooth.prototype, "size", void 0);
if (customElements.get('cat-icon-bluetooth') === undefined) {
    customElements.define('cat-icon-bluetooth', BlocksIconBluetooth);
}
